import { useEffect } from "react";

const usePageDesciption = (description: string) => {
    useEffect(()=>{
        document.querySelector("meta[name='description']")?.setAttribute("content", description);
    },[description])
}
export default usePageDesciption;